import { render, staticRenderFns } from "./UpgradeStrategy.vue?vue&type=template&id=bc8d6d3c&scoped=true&"
import script from "./UpgradeStrategy.vue?vue&type=script&lang=js&"
export * from "./UpgradeStrategy.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeStrategy.vue?vue&type=style&index=0&id=bc8d6d3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8d6d3c",
  null
  
)

export default component.exports